// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Nl-z","breadcrumbForward":"Ol-z","breadcrumbBack":"Pl-z","selected":"Ql-z"};